<template>
  <div class="value-prop-cashflow-goal">
    <img class="image-container" :src="require(`@/assets/${valueProp.imageName}`)">
    <div class="page-content">
      <div class="description">
        <div class="title">{{ valueProp.title }} {{ jobToBeDone }}</div>
        <div class="subtitle">{{ valueProp.subtitle }}</div>
      </div>
      <div class="button-container">
        <riseup-button class="next-question" :title="'הבנתי, מצוין'" :action="next" :size="'small'" />
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import BaseUI from 'base-ui';
import { mapState } from 'vuex';
import valueProps from '../consts/value-props';
import questions from '../consts/questions';
import Segment from '../../../../../../Segment';

export default {
  name: 'ValuePropCashflowGoal',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserGot(`ValueProp-${this.valueProp.name}-Entered`, { valuePropIndex: this.valuePropIndex, valuePropName: this.valueProp.name });
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState('leadQualification', ['answers']),
    valueProp() {
      return _.find(valueProps.VALUE_PROPS, { name: valueProps.VALUE_PROP_NAMES.CASHFLOW_GOAL });
    },
    valuePropIndex() {
      return _.findIndex(valueProps.VALUE_PROPS, { name: valueProps.VALUE_PROP_NAMES.CASHFLOW_GOAL });
    },
    answer() {
      return this.answers[questions.QUESTION_NAMES.JOB_TO_BE_DONE];
    },
    jobToBeDone() {
      const question = _.find(questions.QUESTIONS, { name: questions.QUESTION_NAMES.JOB_TO_BE_DONE });
      if (this.answer) {
        const option = _.find(question.options, { value: this.answer });
        return option.label;
      }
      return question.options[0].label;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .value-prop-cashflow-goal {
    @include white-page-frame;
    height: 100%;

    .image-container {
      width: 100%;
    }

    .page-content {
      @include responsive-padding;
      margin-top: 30px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .description {
        .title {
          font-size: 24px;
          line-height: 1.2;
          width: 100%;
          margin-bottom: 12px;
          font-weight: bold,
        }

        .subtitle {
          font-size: 18px;
          line-height: 1.4;
        }
      }

      .button-container {
        @include responsive-padding-top-bottom;

        .next-question {
          width: 100%;
          white-space: nowrap;
        }
      }
    }
  }

</style>
